import img01 from "images/gallery/01.jpeg";
import img02 from "images/gallery/02.jpeg";
import img03 from "images/gallery/03.jpeg";
import img04 from "images/gallery/04.jpeg";
import img05 from "images/gallery/05.jpeg";
import img06 from "images/gallery/06.jpeg";
import img07 from "images/gallery/07.jpeg";
import img08 from "images/gallery/08.jpeg";
import img09 from "images/gallery/09.jpeg";
import img10 from "images/gallery/10.jpeg";
import img11 from "images/gallery/11.jpeg";
import img12 from "images/gallery/12.jpeg";
import img13 from "images/gallery/13.jpeg";
import img14 from "images/gallery/14.jpeg";
import img15 from "images/gallery/15.jpeg";
import img16 from "images/gallery/16.jpeg";
import img17 from "images/gallery/17.jpeg";
import img18 from "images/gallery/18.jpeg";
import img19 from "images/gallery/19.jpeg";
import img20 from "images/gallery/20.jpeg";
import img21 from "images/gallery/21.jpeg";
import img22 from "images/gallery/22.jpeg";
import img23 from "images/gallery/23.jpeg";
import img24 from "images/gallery/24.jpeg";
import img25 from "images/gallery/25.jpg";
import img26 from "images/gallery/26.jpg";
import img27 from "images/gallery/27.jpg";
import img28 from "images/gallery/28.jpg";
import img29 from "images/gallery/29.jpg";
import img30 from "images/gallery/30.jpg";
import img31 from "images/gallery/31.jpg";

const gallery = [
	{
		img: img01,
		alt: "TecnoCGE - Dettaglio lavorazione a Codogno",
	},
	{
		img: img02,
		alt: "TecnoCGE - Dettaglio lavorazione a Codogno",
	},
	{
		img: img03,
		alt: "TecnoCGE - Dettaglio lavorazione a Codogno",
	},
	{
		img: img04,
		alt: "TecnoCGE - Dettaglio lavorazione a Codogno",
	},
	{
		img: img05,
		alt: "TecnoCGE - Dettaglio lavorazione a Codogno",
	},
	{
		img: img06,
		alt: "TecnoCGE - Dettaglio lavorazione a Codogno",
	},
	{
		img: img07,
		alt: "TecnoCGE - Dettaglio lavorazione a Codogno",
	},
	{
		img: img08,
		alt: "TecnoCGE - Dettaglio lavorazione a Codogno",
	},
	{
		img: img09,
		alt: "TecnoCGE - Dettaglio lavorazione a Codogno",
	},
	{
		img: img10,
		alt: "TecnoCGE - Dettaglio lavorazione a Codogno",
	},
	{
		img: img11,
		alt: "TecnoCGE - Dettaglio lavorazione a Codogno",
	},
	{
		img: img12,
		alt: "TecnoCGE - Dettaglio lavorazione a Codogno",
	},
	{
		img: img13,
		alt: "TecnoCGE - Dettaglio lavorazione a Codogno",
	},
	{
		img: img14,
		alt: "TecnoCGE - Dettaglio lavorazione a Codogno",
	},
	{
		img: img15,
		alt: "TecnoCGE - Dettaglio lavorazione a Codogno",
	},
	{
		img: img16,
		alt: "TecnoCGE - Dettaglio lavorazione a Codogno",
	},
	{
		img: img17,
		alt: "TecnoCGE - Dettaglio lavorazione a Codogno",
	},
	{
		img: img18,
		alt: "TecnoCGE - Dettaglio lavorazione a Codogno",
	},
	{
		img: img19,
		alt: "TecnoCGE - Dettaglio lavorazione a Codogno",
	},
	{
		img: img20,
		alt: "TecnoCGE - Dettaglio lavorazione a Codogno",
	},
	{
		img: img21,
		alt: "TecnoCGE - Dettaglio lavorazione a Codogno",
	},
	{
		img: img22,
		alt: "TecnoCGE - Dettaglio lavorazione a Codogno",
	},
	{
		img: img23,
		alt: "TecnoCGE - Dettaglio lavorazione a Codogno",
	},
	{
		img: img24,
		alt: "TecnoCGE - Dettaglio lavorazione a Codogno",
	},
	{
		img: img25,
		alt: "TecnoCGE - Dettaglio lavorazione a Codogno",
	},
	{
		img: img26,
		alt: "TecnoCGE - Dettaglio lavorazione a Codogno",
	},
	{
		img: img27,
		alt: "TecnoCGE - Dettaglio lavorazione a Codogno",
	},
	{
		img: img28,
		alt: "TecnoCGE - Dettaglio lavorazione a Codogno",
	},
	{
		img: img29,
		alt: "TecnoCGE - Dettaglio lavorazione a Codogno",
	},
	{
		img: img30,
		alt: "TecnoCGE - Dettaglio lavorazione a Codogno",
	},
	{
		img: img31,
		alt: "TecnoCGE - Dettaglio lavorazione a Codogno",
	},
];

export { gallery };
